






































    import { Component, Vue, Mixins } from 'vue-property-decorator';
    import axios from 'axios'
	import { api } from '@/api'
	import Form from '@/mixins/form';

    @Component
    export default class PasswordResetForm extends Mixins(Form) 
    {
        passwordHidden: boolean = true;

        labels: any = {
            password: 'New Password',
            password_confirmation: 'Confirm New Password'
        }

        form: any  = {
            token: null,
            email: null,
            password: null,
            password_confirmation: null
        }

        created() {
            this.form.email = this.$route.params.email
            this.form.token = this.$route.params.token
        }

        submit() {

            if (!this.$refs.form.validate()) {
                return;
            }

            this.loading = true
            
            axios.post(api.path('v1.password.reset'), this.form )
                .then((res) => {
                    this.$toast.success('Your password has been reset.')
                    this.$emit('success', this.form)
                })
                /* .catch(err => {
                    this.handleErrors(err.response.data.errors)
                }) */
                .finally(() => {
                    this.loading = false
                });            
        }
    }
